import { Close, Save } from "@mui/icons-material"
import { LoadingButton } from "@mui/lab";
import { Autocomplete, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, InputAdornment, TextField } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import ArgonButton from "components/ArgonButton"
import ArgonInput from "components/ArgonInput";
import ArgonTypography from "components/ArgonTypography";
import { getDataWithResponse } from "global/getFunc";
import { postSubmit } from "global/postFunc";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";

const TambahKegiatan = ({
    parentData, 
    open, 
    handleCloseDialog, 
    decryptedUser, 
    tahunAnggaran, 
    updating, 
    setUpdating, 
    addReq
}) => {
    const [listKegiatan, setListKegiatan] = useState([])
    const [loading, setLoading] = useState(false)
    const [saving, setSaving] = useState(false)

    const [anggaran, setAnggaran] = useState('')
    const [dataKegiatan, setDataKegiatan] = useState('')

    useEffect(() => {
        if (open) {
            console.log(parentData);
            console.log(tahunAnggaran);
            reqKegiatan();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const reqKegiatan = () => {
        addReq()
        setListKegiatan([])
        setLoading(true)
        getDataWithResponse(
            `/admin-opd/get-dt-kegiatan-by-program/${parentData.kode}`,
            // '/admin-opd/get-kegiatan-by-program/' + tahunAnggaran.regulasi +'-'+parentData.kd_program,
            decryptedUser,
            (res) => {
                setListKegiatan(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
                handleCloseDialog()
            }
        );
    }

    const submit = (e) => {
        addReq()
        e.preventDefault();
        setSaving(true)
        postSubmit(
            '/admin-opd/tr-perencanaan/tambah',
            {
                id: `${tahunAnggaran.ta}-${parentData.kd_pd}-${dataKegiatan.kode}`,
                ta: parentData.ta,
                kd_pd: parentData.kd_pd,
                kode: dataKegiatan.kode,
                program: parentData.kode,
                kegiatan: dataKegiatan.kode,
                uraian: dataKegiatan.uraian,
                anggaran: anggaran.replace(/,(?=\d{3})/g, ''),
                target: '',
                ket: 'KEGIATAN'
            },
            decryptedUser,
            (res) => {
                setSaving(false)
                handleCloseDialog()
                setDataKegiatan('')
                setAnggaran('')
                setUpdating(!updating)
            },
            (res) => {
                setSaving(false)
                handleCloseDialog()
            }
        )
        // console.log('submit');
    }

    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const handleAnggaranChange = (event) => {
        setAnggaran(addCommas(removeNonNumeric(event.target.value)))
    }

    return (
        <Dialog
            open={open}
            maxWidth="md"
            fullWidth
            scroll='paper'
            p={3}
            component='form'
            onSubmit={submit}
            sx={{
                minHeight: '80vh'
            }}
        >
            <DialogTitle>
                <ArgonTypography variant='body2' fontWeight="bold">Input Kegiatan</ArgonTypography>
            </DialogTitle>
            <DialogContent p={3}>
                <ArgonBox mb={1}>
                    {/* <ArgonBox mb={1} ml={0.5}> */}
                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                        Program : {parentData.kode} {parentData.uraian}
                    </ArgonTypography>
                    {/* </ArgonBox> */}
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Kegiatan
                        </ArgonTypography>
                    </ArgonBox>
                    <Autocomplete
                        id="combo-box-demo"
                        options={listKegiatan}
                        fullWidth
                        required
                        getOptionLabel={(option) => option.kode + ' ' + option.uraian}
                        onChange={(event, newValue) => {
                            newValue !== null && setDataKegiatan(newValue)
                        }}
                        onInputChange={(event, newInputValue) => {
                            newInputValue === "" && setDataKegiatan('')
                            // newInputValue.length > 7 && reqDpt()
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Anggaran
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={anggaran}
                        onChange={handleAnggaranChange}
                        autoComplete='off'
                        startAdornment={
                            <InputAdornment position="start">
                                <ArgonTypography component="label" variant="caption" >
                                    Rp
                                </ArgonTypography>
                            </InputAdornment>
                        }
                    />
                </ArgonBox>
            </DialogContent>
            <DialogActions>
                <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                    <Grid item>
                        <ArgonButton color='info' variant='outlined' size="small" startIcon={<Close />} onClick={handleCloseDialog}>Batal</ArgonButton>
                    </Grid>
                    <Grid item>
                        <LoadingButton color='info' variant='contained' size="small" startIcon={<Save />} type='submit' loading={saving}>Simpan</LoadingButton>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

TambahKegiatan.propTypes = {
    parentData: PropTypes.object.isRequired, 
    open: PropTypes.bool.isRequired, 
    handleCloseDialog: PropTypes.func.isRequired, 
    decryptedUser: PropTypes.string.isRequired,
    tahunAnggaran: PropTypes.object.isRequired, 
    updating: PropTypes.bool.isRequired, 
    setUpdating: PropTypes.func.isRequired, 
    addReq: PropTypes.func.isRequired, 
};

export default TambahKegiatan